import { queryClient } from '@/services/graphql/queryClient';

/** TanStack Query v4 expects filters `{ queryKey }`, not a bare query key array. */
export const invalidateQueries = (keys: any) => {
  if (!Array.isArray(keys)) {
    queryClient.invalidateQueries(keys);
    return;
  }
  keys.forEach((key: any) => {
    if (Array.isArray(key)) {
      queryClient.invalidateQueries({ queryKey: key });
    } else {
      queryClient.invalidateQueries(key);
    }
  });
};

export const refetchQueries = (keys: any) => {
  if (!Array.isArray(keys)) {
    queryClient.refetchQueries(keys);
    return;
  }
  keys.forEach((key: any) => {
    if (Array.isArray(key)) {
      queryClient.refetchQueries({ queryKey: key });
    } else {
      queryClient.refetchQueries(key);
    }
  });
};
